import { defineMessages } from 'react-intl'

export const messages = defineMessages({
  salutation: {
    defaultMessage: 'Salutation',
    id: 'use_address_fields.label.salutation'
  },
  salutationMr: {
    defaultMessage: 'Mr',
    id: 'msp.label.salutation.mr'
  },
  salutationMrs: {
    defaultMessage: 'Mrs',
    id: 'msp.label.salutation.mrs'
  },
  firstName: {
    defaultMessage: 'First Name',
    id: 'use_address_fields.label.first_name'
  },
  email: {
    defaultMessage: 'Email address',
    id: 'msp.login_form.label.email'
  },
  lastName: {
    defaultMessage: 'Last Name',
    id: 'use_address_fields.label.last_name'
  },
  password: {
    defaultMessage: 'Password',
    id: 'msp.login_form.label.password'
  },
  repeatPassword: {
    defaultMessage: 'Repeat Password',
    id: 'msp.login_form.label.repeatPassword'
  },
  birthday: {
    defaultMessage: 'Date of birth (optional)',
    id: 'msp.login_form.label.birthday'
  },
  dataProtection: {
    defaultMessage:
      'Yes, I agree to the <a>terms and conditions</a> and the <link>data protection</link> regulations of Melitta Single Portions as well as a credit check.',
    id: 'msp.login_form.label.dataProtection'
  },
  password_match: {
    defaultMessage: 'Passwords do not match.',
    id: 'msp.register_form.error.password_match'
  },
  requirement: {
    defaultMessage: 'The password does not meet the security requirements.',
    id: 'msp.register_form.error.password_requirement'
  },
  invalid: {
    defaultMessage: 'Minimum age 18 years',
    id: 'msp.register_form.error.invalid_data'
  },
  existing_account: {
    id: 'msp.register_form.existing_account',
    defaultMessage:
      'The email address is already in use. You can use the "Reset password" function to set a new password.'
  },
  button: {
    defaultMessage: 'Register Now',
    id: 'msp.register_form.button_register'
  },
  buttonRegisterCheckout: {
    defaultMessage: 'Continue to Shipping Address',
    id: 'msp.register_form.button_register_checkout'
  },
  buttonLoginCheckout: {
    defaultMessage: 'Back to Login',
    id: 'msp.register_form.button_login_checkout'
  }
})

export const validateBirthDay = (date: string): boolean => {
  var today = new Date()
  var birthDate = new Date(date)
  if (
    isNaN(birthDate?.getMonth()) ||
    isNaN(birthDate?.getFullYear()) ||
    birthDate?.getFullYear() < 1900
  )
    return false
  var age = today.getFullYear() - birthDate.getFullYear()
  var m = today.getMonth() - birthDate.getMonth()
  if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
    age--
  }
  return age >= 18
}
